/** @jsx jsx */
import { DottedList, DottedListItem, Link, Paragraph, TypeApplicationIcon } from "@eworkit/iris";
import { FC } from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import { jsx } from "theme-ui";

import { IconedHeader } from "@/components/headers/IconedHeader";
import { getJobRequestClientInfo } from "@/data/job-requests";
import { JobRequestShort } from "@/data/job-requests/types/JobRequestShort";
import { router } from "@/views/router";

interface JobRequestHeaderProps {
  jobRequest: JobRequestShort;
  header?: string;
}

export const JobRequestHeader: FC<JobRequestHeaderProps> = ({ jobRequest, header, children }) => {
  const clientInfo = getJobRequestClientInfo(jobRequest);

  return (
    <IconedHeader icon={<TypeApplicationIcon />} heading={header || jobRequest.title}>
      <DottedList>
        <DottedListItem>
          <Link
            as={ReactRouterLink}
            to={router.get("job-requests.detail", { jobRequestId: jobRequest.id }).path}
            target="_blank">
            {jobRequest.systemId}
          </Link>
        </DottedListItem>

        {clientInfo.name && (
          <DottedListItem>
            <Paragraph color="n700">{clientInfo.name}</Paragraph>
          </DottedListItem>
        )}

        {children}
      </DottedList>
    </IconedHeader>
  );
};
